import React from "react";
import { useState } from "react";


export default function EditOperations({ fileContent, setFileContent }) {
    const [editText, setEditText] = useState(fileContent || "");
  
    const handleSave = () => {
      setFileContent(editText);
    };
  
    return (
      <div>
        <textarea value={editText} onChange={(e) => setEditText(e.target.value)} rows="5" cols="50" />
        <button onClick={handleSave}>Save Changes</button>
      </div>
    );
  }